import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=a9ddecf0&scoped=true"
import script from "./Default.vue?vue&type=script&lang=ts"
export * from "./Default.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ddecf0",
  null
  
)

export default component.exports